import React from 'react'
import { FormatValueDecimal } from '../../utils/Validate'

const ViewOrderCharges = ({ viewItem, percentageValue, currencyDetail }) => {

    return (
        <>
            <div className="card-header">
                <h1>Order Charges</h1>
            </div>
            <div className="card-body">
                <div className="row mb-2">
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <p>Total list price</p>
                        <h6>{FormatValueDecimal(viewItem?.totalListPrice)}</h6>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <p>Net price</p>
                        <h6>{FormatValueDecimal(viewItem?.netPrice)}</h6>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <p>Special charges</p>
                        <h6>{FormatValueDecimal(viewItem?.specialCharges)}</h6>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <p>Total Selling Price</p>
                        <h6>{FormatValueDecimal(viewItem?.totalSellingPrice)}</h6>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <p>Special discounts</p>
                        <h6>{viewItem?.discountPercentage || 0} %</h6>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <p>Tax</p>
                        <h6>{viewItem?.taxPercentage || 0} %</h6>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <p>Average Sales Margin</p>
                        <h6>{viewItem?.salesMarginPercentage || 0} %</h6>
                    </div>
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <p>Freight & delivery charges</p>
                        <h6>{FormatValueDecimal(viewItem?.freightCharges)}</h6>
                    </div>
                </div>
                <div className="row mb-2">
                    <div className="col-xxl-3 col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12">
                        <p>Custom duty</p>
                        <h6>{FormatValueDecimal(percentageValue?.customDuty)}</h6>
                    </div>
                </div>
                <div className="table-responsive order-charges-table d-none">
                    <table className="table table-borderless">
                        <tbody>
                            <tr>
                                <td>
                                    <p>Total list price</p>
                                    <h6>{FormatValueDecimal(viewItem?.totalListPrice)}</h6>
                                </td>
                                <td>
                                    <p>Net price</p>
                                    <h6>{FormatValueDecimal(viewItem?.netPrice)}</h6>
                                </td>
                                <td>
                                    <p>Special charges</p>
                                    <h6>{FormatValueDecimal(viewItem?.specialCharges)}</h6>
                                </td>
                                <td>
                                    <p>SDR</p>
                                    <h6>{FormatValueDecimal(viewItem?.sdrCharges)}</h6>
                                </td>
                                <td>
                                    <p>Total Selling Price</p>
                                    <h6>{FormatValueDecimal(viewItem?.totalSellingPrice)}</h6>
                                </td>
                                <td>
                                    <p>Special discounts</p>
                                    <h6>{viewItem?.discountPercentage || 0} %</h6>
                                </td>
                            </tr>
                            <tr>
                                <td>
                                    <p>Tax</p>
                                    <h6>{viewItem?.taxPercentage || 0} %</h6>
                                </td>
                                <td>
                                    <p>Average Sales Margin</p>
                                    <h6>{viewItem?.salesMarginPercentage || 0} %</h6>
                                </td>
                                <td>
                                    <p>Freight & delivery charges</p>
                                    <h6>{FormatValueDecimal(viewItem?.freightCharges)}</h6>
                                </td>
                                <td>
                                    <p>Custom duty</p>
                                    <h6>{FormatValueDecimal(percentageValue?.customDuty)}</h6>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </>
    )
}

export default ViewOrderCharges